var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  items: _vm.reclamations,
                  fields: _vm.fields
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(dateReclamation)",
                    fn: function(data) {
                      return [
                        _c("AffichageDate", { attrs: { date: data.value } })
                      ]
                    }
                  },
                  {
                    key: "cell(montantAvoir)",
                    fn: function(data) {
                      return [
                        _c("span", [_vm._v(_vm._s(data.value))]),
                        data.value > 0
                          ? _c("span", { staticClass: "ml-1" }, [_vm._v("€")])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(dateRelivraisonSouhaitee)",
                    fn: function(data) {
                      return [
                        _c("AffichageDate", { attrs: { date: data.value } })
                      ]
                    }
                  },
                  {
                    key: "cell(estTraitee)",
                    fn: function(data) {
                      return [
                        data.value
                          ? _c("i", {
                              staticClass: "fas fa-check text-success"
                            })
                          : _c("i", { staticClass: "fas fa-times text-danger" })
                      ]
                    }
                  },
                  {
                    key: "cell(id)",
                    fn: function(data) {
                      return [
                        !data.item.estTraitee
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.traiter(data.value)
                                  }
                                }
                              },
                              [_vm._v("Marquer traitée")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "card-header bg-gradient-bleu text-white" },
      [
        _c("div", { staticClass: "card-title" }, [
          _vm._v("Liste des réclamations")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }